import { EventState } from './event-state.interface'

export function createEventState(): EventState {
  return {
    connected: false,
    error: null
  }
}
